import { AddTask, VButton, VFlex } from '@/package';

const TaskTableEmptyList = ({ onClick }: { onClick: () => void }) => {
  return (
    <VFlex className="w-full py-16" justify="center" items="center">
      <VFlex className="w-[394px] flex-col items-center gap-4">
        <VFlex direction="col" className="items-center gap-2 text-blue-300">
          <AddTask className="h-[66px] w-[66px]" />
          <div className="text-center text-body-xl">
            There are no tasks yet. <br />
            Create a task to get started!
          </div>
        </VFlex>

        <VButton onClick={onClick}>
          <AddTask className="h-5 w-5" />
          Create Task
        </VButton>
      </VFlex>
    </VFlex>
  );
};

export default TaskTableEmptyList;
